import script from "./dycallback.vue?vue&type=script&setup=true&lang=js"
export * from "./dycallback.vue?vue&type=script&setup=true&lang=js"

import "./dycallback.vue?vue&type=style&index=0&id=9eda1dd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eda1dd6"]])

export default __exports__